     const urlData = {
         routeArr : ['account','account-payment','my-trips','id-verification','notifications', 'promocode', 'invite-friends', 'how-it-works', 'contact-support', 'invite-friends', 'send-feedback', 'legal-content'],
         tabArr: ['Account','Payment','My Trips','ID Verification','Notifications','Promo Code','Invite Friends','How AWB Works','Contact Support', 'Invite Friends', 'Send Feedback', 'Legal' ]
     }
      module.exports = urlData;



// WEBPACK FOOTER //
// app/profile/profile_navbar/url_config.jsx